<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-card class="backClass" header="Received">
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">
            Receiving by Month
            <small style="font-weight:600; color:#20a8d8">
              (YTD)
            </small>
          </h5>
          <b-button
            v-if="details == 1"
            @click="detailView"
            class="btn-outline ml-3"
            variant="outline-primary"
            right
          >
            Back
          </b-button>
          <div class="card-header-actions">
            <b-button
              @click="toggleFullScreen"
              style="height: 26px; width: 26px"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button>
          </div>
        </div>
        <div style="width: 100%; display: flex; justify-content: flex-end;">
        </div>
        <div class="chart-wrapper">
          <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <div style="width: 100%; display: flex; justify-content: flex-end;">
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../router";
import { Switch as cSwitch } from "@coreui/vue";

export default {
  name: "RepairAnalytics-Stacked",
  components: {
    router,
    highcharts: Chart,
    cSwitch
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "details"],
  data: function() {
    return {
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      totalValue: null,
      valueQuantity: false,
      toggleData: false,
      dateFrom: "",
      dateTo: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      chartOptions: {
        tooltip: {
          formatter: function() {
            return;
          }
        },
        chart: {
          type: "column",
          backgroundColor: "transparent"
        },
        exporting: {
          enabled: true
        },
        title: {
          text: "",
          style: {
            color: "white",
            display: ""
          }
        },
        legend: {
          itemStyle: {
            color: "white"
          }
        },
        xAxis: {
          categories: [],
          labels: {
            style: {
              color: "white"
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total repair by Month"
          },
          labels: {
            style: {
              color: "white"
            }
          },
          stackLabels: {
            enabled: true,
            formatter: function() {
              return "Total: " + this.total;
            },
            style: {
              fontWeight: "bold",
              color: "white"
            }
          }
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
              formatter: function() {
                return "TEST";
              }
            },
            point: {
            events: {
              click: ({ point }) => {
                this.$emit("switch", [point.series.name, point.dateParam, point.dateFrom, point.dateTo]);
                }
              }
            },
            events: {
              legendItemClick: (data) => {
                this.totalValue = null;
              }
            },
          }
        },
        series: []
      }
    };
  },

  watch: {
    totalValue(value) {
      var chartSeries = this.$refs.backRef.chart.series;
      var pointSum = 0;
      chartSeries.forEach(function(obj) {
        if(obj.visible == true) {
          obj.yData.forEach(function(datas) {
            pointSum += datas;
          })
        }
      })
      this.totalValue = pointSum;
      if (!this.valueQuantity || this.valueQuantity == "false") {
        this.chartOptions.title.text = "Total units: " + this.totalValue;
      } else {
        this.chartOptions.title.text = "Total: " + "$" + this.totalValue.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
      }
    },
    fullscreen(value) {
      if (value == false) {
        this.$emit("detailViewRepair");
      }
    },
    valueQuantity(value) {
      this.fetchData();
      if (this.fullScreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
    },
    toggleData(param) {
      var chartSeries = this.$refs.backRef.chart.series;
      chartSeries.forEach(obj => {
        if (param === "false") {
          obj.show();
        } else {
          obj.hide();
        }
      });
    }
  },

  methods: {
    detailView() {
      this.$emit("detailViewRepair");
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    returnDate(month) {
      const createStart = new Date();
      const startingYear = createStart.getFullYear()

      if (month == 'January') {
        return startingYear+'-01-01'
      } else if (month == 'February') {
        return startingYear+'-02-01'
      } else if (month == 'March') {
        return startingYear+'-03-01'
      } else if (month == 'April') {
        return startingYear+'-04-01'
      } else if (month == 'May') {
        return startingYear+'-05-01'
      } else if (month == 'June') {
        return startingYear+'-06-01'
      } else if (month == 'July') {
        return startingYear+'-07-01'
      } else if (month == 'August') {
        return startingYear+'-08-01'
      } else if (month == 'September') {
        return startingYear+'-09-01'
      } else if (month == 'October') {
        return startingYear+'-10-01'
      } else if (month == 'November') {
        return startingYear+'-11-01'
      } else {
        return startingYear+'-12-01'
      }
    },
    fetchData() {
      this.loadingData = true;
      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }
      let params = {};
      const createStart = new Date();
      const startingYear = createStart.getFullYear()
      params = {
        date_from: startingYear+"-01-01",
        date_to: this.dateTo,
        type: finType
      };
      this.$http
        .get("api/aoi/charts/daily_by_month.php", {
          params
        })
        .then(
          res => {
            let myArray = res.data;
            let xAxis = [];
            var datum = [];

            var power = {
              name: "Total",
              data: [],
              color: "rgb(247, 163, 92)"
            };

            let sortedKeys = Object.keys(myArray).sort((a, b) => new Date(a + "-01") - new Date(b + "-01"));

            sortedKeys.forEach(key => {
              datum.push([key, myArray[key]]);
            });

            datum.forEach(obj => {
              let [year, month] = obj[0].split("-");

              const monthNumber = parseInt(month, 10);

              // Start and end dates
              const dateFrom = `${year}-${month.padStart(2,'0')}-01`;
              const lastDay = new Date(year, monthNumber, 0).getDate();
              const dateTo = `${year}-${month.padStart(2,'0')}-${lastDay}`;

              const monthNames = {
                "01": "January",
                "02": "February",
                "03": "March",
                "04": "April",
                "05": "May",
                "06": "June",
                "07": "July",
                "08": "August",
                "09": "September",
                "10": "October",
                "11": "November",
                "12": "December"
              };

              xAxis.push(`${monthNames[month]} ${year}`);

              let tempValue = 0;
              Object.entries(obj[1]).forEach(([key, value]) => {
                tempValue+= parseInt(value);
              });
              power.data.push({
                y: tempValue,
                dateParam: obj[0],
                name: `${monthNames[month]} ${year}`,
                dateFrom: dateFrom,
                dateTo: dateTo
              });

            });

            this.chartOptions.xAxis.categories = xAxis;
            this.chartOptions.series[0] = power;

            // Getting total amount wihtout response
            var seriesData = this.chartOptions.series;
            var pointSum = 0;
            seriesData.forEach(function(point) {
              var datasValue = point.data;
              datasValue.forEach(function(value) {
                pointSum += value.y;
              })
            });

            this.totalValue = pointSum;
              this.chartOptions.title.text = "Total units: " + pointSum;

              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": " +
                  this.y +
                  " units"
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return this.y;
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return "Total: " + this.total;
              };

            if(this.details == 1 && this.fullscreen == false) {
            this.toggleFullScreen();
            this.chartOptions.chart.height = '45%';
            }

            this.loadingData = false;
          },
          err => {
            console.log(err);
            this.loadingData = false;
          }
        );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    modalDateEvent() {
      if (this.fullScreen) {
        this.toggleFullScreen();
        this.modalDate = true;
      } else {
        this.modalDate = true;
      }
    },
    downloadPDF() {
      this.$refs.backRef.chart.options.title.text =
        "Repair Analytics By Product Type | Year-to-date (YTD)";

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.backRef.chart.options.yAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "RepariAnalyticsByProductGroup-" + this.dateTo
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "white";
    }
  },
  mounted() {
    if (!localStorage.getItem("aoi_user")) {
      router.push("/pages/login/");
    }

    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
    }
    this.valueQuantity = false;

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
